module.exports = __webpack_public_path__ + "img/logo.69914aa4.png";